import { TypeSauceClipConfig } from '@types'
import i18n from 'core/i18n'

export type GuestLoginType = {
  agreementUrl: string
  collectUserData: boolean
  use: boolean
}

export type AlarmType = {
  agreementUrl: string
  use: boolean
}

type CollectionLoginType = {
  history: string | null
  mobile: string | null
  pc: string | null
  webview: string | null
}

export type TypeConfig = {
  airbridge: {
    use: boolean
    id: string | null
    name: string | null
  }
  logo: string | null
  logoAltText: string
  liveWording: string
  marketingGTM: {
    use: boolean
    gtmId: string | null
    gtagId: string | null
  }
  scheduleWording: string
  curationWording: string
  allWording: string
  hashRouter: boolean
  isProductPriceVisible?: boolean
  broadcastLimit: number
  searchIconVisible: boolean
  customSearchBar: boolean
  searchBarPlaceholder: string
  guestLogin: Partial<GuestLoginType>
  alarm: AlarmType
  collectionLogin: CollectionLoginType
  sauceclip?: TypeSauceClipConfig
  /** 리다이렉트 설정 */
  redirection: {
    /** 회원 로그인의 경우 리다이렉트할 로그인 링크 정보 (쿼리스트링에 'loginUrl'항목이 있는 경우 미동작) */
    login: {
      /** 웹뷰 환경인 경우 로그인 링크 정보 */
      webview: string | null
      /** 모바일 환경인 경우 로그인 링크 정보 */
      mobile: string | null
      /** PC 환경인 경우 로그인 링크 정보 */
      pc: string | null
      /** 리다이렉트 방법 */
      history: 'href' | 'replace'
      /** 플레이어 링크에 있는 쿼리스트링 포함 여부 */
      addQuery: boolean
    }
    /** 닫기 시 리다이렉트할 링크 정보 */
    broadcastClose: {
      /** 웹뷰 환경인 경우 닫기 링크 정보 */
      webview: string | null
      /** 모바일 환경인 경우 닫기 링크 정보 */
      mobile: string | null
      /** PC 환경인 경우 닫기 링크 정보 */
      pc: string | null
      /** 리다이렉트 방법 */
      history: 'href' | 'replace'
      /** Deprecated */
      mobileCloseInVisible: boolean
    }
    /** 로고 클릭 설정 */
    logoClick: {
      /** 로고 클릭 기능 사용 여부 */
      use: boolean
      /** 모바일 환경인 경우 리다이렉트 링크 정보 */
      mobile: string | null
      /** PC 환경인 경우 리다이렉트 링크 정보 */
      pc: string | null
    }
  }
}

export type TypeTheme = {
  background: string
  badge: string
  scheduleTime: string
  scheduleTimeFeed: string
  icon: string
  border: string
  thumbnailLineColor: string
  loading: string
  skeleton: string
  skeletonGradation: string
  all: string
  color: {
    primary: string
  }
  font: {
    primary: string
    secondary: string
    third: string
  }

  // searchBar: boolean;
  boxShadow: string
  curationBackground: string
  scheduleAll: boolean
  curationAll: boolean
  shopName: boolean
  shopNameFont: string
  discount: string
  logo: string
  logoUse?: boolean
}

export const defaultConfig: TypeConfig = {
  airbridge: {
    use: false,
    id: null,
    name: null,
  },
  logo: 'https://via.placeholder.com/150x50',
  logoAltText: 'partner_logo',
  liveWording: 'LIVE',
  marketingGTM: {
    use: false,
    gtagId: null,
    gtmId: null,
  },
  scheduleWording: i18n.t('schedule_wording'),
  curationWording: i18n.t('curation_wording'),
  allWording: i18n.t('all_wording'),
  hashRouter: false,
  isProductPriceVisible: true,
  broadcastLimit: 10,
  searchIconVisible: true,
  customSearchBar: false,
  searchBarPlaceholder: i18n.t('search_bar_placeholder'),
  guestLogin: {
    agreementUrl: 'https://d2l8gjzronllm0.cloudfront.net/config/lg-uplus/privacy_terms.html',
    collectUserData: false,
    use: false,
  },
  alarm: {
    agreementUrl: 'https://d2l8gjzronllm0.cloudfront.net/config/uiux/alarm_privacy_terms.html',
    use: false,
  },
  collectionLogin: {
    history: null,
    pc: null,
    mobile: null,
    webview: null,
  },
  redirection: {
    login: {
      history: 'href',
      webview: null,
      mobile: null,
      pc: null,
      addQuery: false,
    },
    broadcastClose: {
      history: 'href',
      webview: null,
      mobile: null,
      pc: null,
      mobileCloseInVisible: false,
    },
    logoClick: {
      use: false,
      mobile: null,
      pc: null,
    },
  },
}

export const defaultTheme: TypeTheme = {
  all: '#ff2d55',
  /* 감싸고있는 돔컬러 */
  background: '#f8f8f9',
  /* 라이브 뱃지 */
  badge: '#ff2d55',
  border: '#edeff0',
  thumbnailLineColor: '#edeff0',
  /* 쉐도우 */
  boxShadow: 'rgba(0, 0, 0, 0.25)',
  /* 컬러 */
  color: {
    primary: '#ffffff',
  },
  /* 스케줄 타임 */
  scheduleTime: '#ff2d55',
  scheduleTimeFeed: '#ff2d55',
  /* 아이콘 */
  icon: 'rgb(78, 84, 89)',
  loading: '#1d0e0b',
  skeleton: '#cccccc60',
  skeletonGradation: 'linear-gradient(90deg, #ffffff00, #ffffff70, #ffffff00)',

  /* 폰트색상 */
  font: {
    primary: '#1b1c1d',
    secondary: '#a8aeb3',
    third: '#555555',
  },

  /* 큐레이션 상세 bg */
  curationBackground: '#f7f7f7',
  // searchBar: true,
  scheduleAll: true,
  curationAll: true,
  shopName: true,
  shopNameFont: '#616568',
  discount: '#ff383b',
  logo: 'https://via.placeholder.com/150x50',
  logoUse: true,
}

export const defaultThemeB: TypeTheme = {
  all: '#000',
  background: '#000',
  badge: '#000',
  border: '#000',
  thumbnailLineColor: '#edeff0',
  boxShadow: 'rgba(0, 0, 0, 0.25)',
  color: {
    primary: 'red',
  },
  curationAll: true,
  curationBackground: '#000',
  discount: '#ff383b',
  font: {
    primary: '#000',
    secondary: '#000',
    third: '#000',
  },
  icon: '#000',
  loading: '#1d0e0b',
  scheduleAll: true,
  scheduleTime: '#ff2d55',
  scheduleTimeFeed: '#ff2d55',
  shopName: true,
  shopNameFont: '#616568',
  skeleton: '#cccccc60',
  skeletonGradation: 'linear-gradient(90deg, #ffffff00, #ffffff70, #ffffff00)',
  logo: 'https://via.placeholder.com/150x50',
  logoUse: false,
}
